/* @flow */
const APPLICATION_NAME = "Staza";
const DEFAULT_ICON_URL =
  "https://staza-assets.s3-eu-west-1.amazonaws.com/staza/logo/staza-logo.png";

export default {
  APPLICATION_NAME,
  DEFAULT_ICON_URL
};
